import React, { createContext, useState, useContext, useEffect } from 'react';
import { useAuth } from './AuthContext';

const SchoolContext = createContext();

export const SchoolProvider = ({ children }) => {
  const { user } = useAuth();
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [availableSchools, setAvailableSchools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.school_users) {
      // Filtrar apenas escolas ativas do usuário
      const activeSchools = user.school_users
        .filter(su => su.active)
        .map(su => ({
          id: su.school?.id || su.school,
          name: su.school?.name || 'Escola',
          role: su.role,
          role_display: su.role_display
        }));

      // Remover escolas duplicadas (quando usuário tem múltiplos papéis na mesma escola)
      const uniqueSchools = activeSchools.reduce((acc, school) => {
        if (!acc.find(s => s.id === school.id)) {
          acc.push(school);
        }
        return acc;
      }, []);

      setAvailableSchools(uniqueSchools);

      // Tentar recuperar escola salva no localStorage
      const savedSchoolId = localStorage.getItem('selectedSchool');

      if (savedSchoolId && activeSchools.find(s => s.id === savedSchoolId)) {
        // Se a escola salva ainda está disponível, usar ela
        setSelectedSchool(savedSchoolId);
      } else if (activeSchools.length > 0) {
        // Caso contrário, usar a primeira escola disponível
        const firstSchool = activeSchools[0].id;
        setSelectedSchool(firstSchool);
        localStorage.setItem('selectedSchool', firstSchool);
      }

      setLoading(false);
    }
  }, [user]);

  const changeSchool = (schoolId) => {
    setSelectedSchool(schoolId);
    localStorage.setItem('selectedSchool', schoolId);
  };

  const getSelectedSchoolData = () => {
    return availableSchools.find(s => s.id === selectedSchool);
  };

  return (
    <SchoolContext.Provider
      value={{
        selectedSchool,
        setSelectedSchool: changeSchool,
        availableSchools,
        loading,
        getSelectedSchoolData
      }}
    >
      {children}
    </SchoolContext.Provider>
  );
};

export const useSchool = () => {
  const context = useContext(SchoolContext);
  if (!context) {
    throw new Error('useSchool must be used within a SchoolProvider');
  }
  return context;
};
